import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

let socket = null;
let joinedRooms = new Set();

export const initializeSocket = (token) => {
  if (socket?.connected) return socket;

  // Disconnect stale socket if exists but not connected
  if (socket && !socket.connected) {
    socket.disconnect();
    socket = null;
  }

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  socket.on('connect', () => {
    console.log('🔌 Socket connected:', socket.id);
    // Re-join rooms on reconnect
    joinedRooms.forEach(room => {
      socket.emit('join', room);
    });
  });

  socket.on('disconnect', (reason) => {
    console.log('🔌 Socket disconnected:', reason);
  });

  socket.on('connect_error', (error) => {
    console.warn('🔌 Socket connection error:', error.message);
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    joinedRooms.clear();
  }
};

export const joinRoom = (room) => {
  joinedRooms.add(room);
  if (socket?.connected) {
    socket.emit('join', room);
  }
};

export const leaveRoom = (room) => {
  joinedRooms.delete(room);
  if (socket?.connected) {
    socket.emit('leave', room);
  }
};

export const isSocketConnected = () => socket?.connected || false;